import styled from 'styled-components'

import commonCss from '~/core/css'

export default styled.hr`
  ${commonCss.resetBoxProps};

  display: block;
  width: 100%;

  margin-left: ${props => (props.isFullLength ? '0' : '16px')};
  border-bottom: 1px solid #F2F2F2;

  ${props => props.parent && `${props.parent}:hover & {
    margin-left: 0;
  }`};
`
